<template>
  <div class="echarts">
    <div class="top item" style="height:1000px">
      <div class="searchBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="90px" size="mini" >
         <div class="searchBox inpBox">
              <div>
              <el-form-item label="货物类型:" class="jiage" prop="productTypeName">
                <el-select  v-model="searchFrom.productTypeName"  value-key="productId"  placeholder="请选择">
                  <el-option v-for="item in productTypes" :label="item.name" :value="item.name" :key="item.productId"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="起始地:" class="diqu1" >
                <shengShiXian :rowData="this.searchFrom" @handleChange="handleChange" ref="reference"></shengShiXian>
              </el-form-item>
              <el-form-item label="目的地:" class="diqu1" >
                <shengShiXian :rowData="this.searchFrom" @handleChange="handleChange1" ref="reference1"></shengShiXian>
              </el-form-item>
              <!-- <i class="el-icon-location-information" style="color: #0e6eec;margin: 5px 0px 0px 60px"></i>&nbsp;
              <el-form-item label="" prop="receivingAddress" class="czlx">
                <el-input  placeholder="起始地" v-model="searchFrom.deliverAddress"></el-input>
                <i class="fa fa-arrows-h" aria-hidden="true"></i>
                <el-input  placeholder="目的地" v-model="searchFrom.receivingAddress"></el-input>
              </el-form-item> -->

              <!-- <i class="el-icon-date" style="color: #0e6eec;margin: 5px 1px 0px 30px"></i>&nbsp; -->
              <el-form-item label="日期:" prop="createTime">
                <el-date-picker
                  style="width:310px"
                  v-model="searchFrom.createTimes"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="searchFn">查询</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
              </el-form-item>
            </div>

        </div>
        <!-- <div class="searchBtnBox">
          <el-form-item>
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
        </div> -->
      </el-form>
      </div>
      <hr>
      <div class="whole">
        <div class="whole box1">
          <div class="Boxone">
          <div class="statistics1">
            <div class="title">
              <h4>数据统计</h4>
            </div>
            <div class="leiji">
              <div class="box1item" style="background:#5087EC">
                <div class="da">{{tongji.trainNum?tongji.trainNum:0}}</div>
                <div class="xiao">累计车次(次)</div>
              </div>
              <div class="box1item" style="background:#F2BD42">
                <div v-if="tongji.weight < 10000">
                  <div class="da">{{tongji.weight?tongji.weight:0}}</div>
                  <div class="xiao">累计拉运量(吨)</div>
                </div>
                <div v-else>
                  <div class="da">{{(tongji.weight/10000).toFixed(3)}}</div>
                  <div class="xiao">累计拉运量(万吨)</div>
                </div>
              </div>
              <div class="box1item" style="background:#58A55C">
                <div v-if="tongji.weight < 10000">
                  <div class="da">{{tongji.price?tongji.price:0}}</div>
                  <div class="xiao">累计运费(元)</div>
                </div>
                <div v-else>
                  <div class="da">{{(tongji.price/10000).toFixed(3)}}</div>
                  <div class="xiao">累计运费(万元)</div>
                </div>
              </div>
            </div>
          </div>
          <div class="statistics2" >
            <div class="title">
              <h4>运价统计</h4>
            </div>
            <div class="whole1" id="zhu"></div>
          </div>
        </div>
        <div class="Box2">
            <div class="classify1">
              <div class="title">
               <h4>货物分类</h4>
              </div>
              <div class="whole1" id="gd"></div>
            </div>
            <div class="classify2">
              <div class="title">
               <h4>重量分类</h4>
              </div>
              <div class="whole1" id="weight"></div>
            </div>
        </div>
       </div>
        <div class="whole Box3">
          <div class="title">
            <h4>运量波动/运次波动/运费波动</h4>
          </div>
          <div class="whole1" id="zhe"></div>
        </div>
    </div>
   </div>
  </div>
</template>

<script>
import {
  productNameList, // 货物类型
  getTrafficCountNoGroup, // 数据统计
  productWeightList, // 重量分类
  getPriceCount, // 运价统计
  getTrafficCount // 12月波动折线图
} from '@/api/soc-customer'
import { dropDownList } from '@/api/soc-stock'
import { emptyFn, dateTimeFormat, toFixed } from '@/utils/util'
import shengShiXian from '@/components/common/shengShiXian.vue'

export default {
  components: {
    shengShiXian
  },
  data () {
    return {
      toFixed: toFixed,
      flag: false,
      addFrom: {},
      searchFrom: {},
      productTypes: [],
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      loading: false,
      tableList: [],
      dateVal: null,
      tongji: {},
      productWeight: {}

    }
  },
  created () {
    this.getList()
  },
  mounted () {
    dropDownList().then(res => {
      this.productTypes = res
    })
    getTrafficCountNoGroup().then(res => {
      this.tongji = res[0]
    })
    this.zheFn()
    this.zhuFn()
    this.goodFn()
    this.weightFn()
  },
  methods: {
    // 地区选中
    handleChange (value) {
      //  console.log(this.$refs.reference);
      if (value) {
        this.searchFrom.deliverAddress = value[0].name + value[1].name + value[2].name
      }
      console.log(2222222222222222222)
      console.log(this.$refs.reference.$refs.cs.$refs.panel.getCheckedNodes()[0])
    },
    // 地区选中
    handleChange1 (value) {
      if (value) {
        this.searchFrom.receivingAddress = value[0].name + value[1].name + value[2].name
      }
    },
    // 货主新增趋势
    zheFn (searchFrom) {
      getTrafficCount(this.searchFrom).then(res => {
        var Data1 = []
        var Data2 = []
        var Data3 = []
        var nameData = []
        console.log(res)
        res.forEach((item, index) => {
          nameData.push(item.createMonth)
          Data1.push(item.weight)
          Data2.push(item.trainNum)
          Data3.push(item.price)
        })
        let _this = this
        let idChart = _this.$echarts.init(document.getElementById('zhe'))
        // 绘制图表--折线图
        var idChartOption = {
          tooltip: {
            trigger: 'axis',
            formatter: function (c) {
              // let str = '';
              var relVal = c[0].name
              c.forEach((item) => {
                // console.log(item);
                if (item.seriesName == '运量') {
                  item.format = ' 吨'
                } else if (item.seriesName == '运次') {
                  item.format = ' 次'
                } else {
                  item.format = ' 元'
                }
                relVal += '<br/>' + item.marker + item.seriesName + ': ' + item.value + item.format
              })
              return relVal
            }
          },
          legend: {
            data: ['运量', '运次', '运价']
          //   selectedMode: 'single',//每次显示一条线
          //   selected:{
          //     '运量':true,
          //     '运次':false,
          //     '运价':false
          // }
          },
          grid: {
            left: '6%',
            right: '8%',
            bottom: '9%',
            top: '10%',
            containLabel: true
          },
          xAxis: {
            name: '日期',
            type: 'category',
            data: nameData,
            axisLine: {
              lineStyle: {
                // color: '#14D5FF'
              }
            },
            axisLabel: {
              interval: 0,
              rotate: 60,
              textStyle: {
                fontFamily: 'Microsoft YaHei'
              }
            }
          },
          yAxis: {
            name: '',
            type: 'value'
          },
          // yAxis: [
          //   {
          //     type: 'value',
          //     position: 'left',
          //     axisLabel: {
          //          formatter: '{value} 吨'
          //     }
          //   },
          //   {
          //     type: 'value',
          //     position: 'left',
          //     axisLabel: {
          //          formatter: '{value} 次'
          //     }
          //   },
          //   {
          //     type: 'value',
          //     position: 'left',
          //     axisLabel: {
          //          formatter: '{value} 元'
          //     }
          //   }
          // ],
          series: [
            {
              name: '运量',
              type: 'line',
              color: '#5470c6',
              data: Data1
              //  yAxisIndex: 0

            },
            {
              name: '运次',
              type: 'line',
              color: '#91cc75',
              data: Data2
              //  yAxisIndex: 1

            },
            {
              name: '运价',
              type: 'line',
              color: '#fac858',
              data: Data3
              //  yAxisIndex: 2
            }
          ]
        }
        idChart.setOption(idChartOption)
      })
    },
    // 货物分类
    goodFn (searchFrom) {
      productNameList(this.searchFrom).then(res => {
        this.productType = res
        let arr = []
        this.productType.forEach(item => {
          arr.push({ productName: item.productName, weightSum: item.weightSum })
        })
        // console.log(arr);
        let _this = this
        let idChart = _this.$echarts.init(document.getElementById('gd'))
        var dataArr = []
        for (var i = 0; i < arr.length; i++) {
          dataArr.push({
            name: arr[i].productName,
            value: arr[i].weightSum
          })
        }
        var option = {
          tooltip: {
            trigger: 'item'
          },
          color: ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'],
          series: [
            {
              type: 'pie',
              radius: ['20%', '60%'],
              avoidLabelOverlap: true,
              label: {
                show: true,
                fontSize: '12',
                color: '#000000'
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: '20',
                  fontWeight: 'bold'
                }
              },
              labelLine: {
                show: true
              },
              data: dataArr
            }
          ]
        }
        idChart.setOption(option)
      })
    },
    // 重量分类
    weightFn (searchFrom) {
      productWeightList(this.searchFrom).then(res => {
        this.productWeight = res[0]
        var dataArr = []
        for (const key in this.productWeight) {
          const element = this.productWeight[key]
          if (element != 0) {
            dataArr.push({
              name: key,
              value: element
            })
          }
        }
        let _this = this
        let idChart = _this.$echarts.init(document.getElementById('weight'))
        var option = {
          color: ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'],
          title: {
            left: 'center'
          },
          tooltip: {
            trigger: 'item'
          },
          series: [
            {
              type: 'pie',
              radius: '60%',
              data: dataArr,
              avoidLabelOverlap: true,
              label: {
                show: true,
                fontSize: '12',
                color: '#000000'
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: '20',
                  fontWeight: 'bold'
                }
              }
              // emphasis: {
              //   itemStyle: {
              //     shadowBlur: 10,
              //     shadowOffsetX: 0,
              //     shadowColor: 'rgba(0, 0, 0, 0.5)'
              //   }
              // }
            }
          ]
        }
        idChart.setOption(option)
      })
    },
    // 货主活跃度对比
    zhuFn (searchFrom) {
      getPriceCount(this.searchFrom).then(res => {
        let maxNames = []
        let minNames = []
        let avgPrice = []
        let valueArr = []
        res.forEach((item, index) => {
          maxNames.push(item.maxPrice)
          minNames.push(item.minPrice)
          avgPrice.push(item.avgPrice)
          valueArr.push(item.createMonth)
        })
        let myChart = this.$echarts.init(document.getElementById('zhu'))
        let option = {
          color: ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de'],
          grid: {
            left: '5%',
            right: '5%',
            bottom: '9%',
            top: '10%',
            containLabel: true
          },
          tooltip: {
            trigger: 'axis',
            formatter: function (params) {
              var relVal = params[0].name
              for (var i = 0, l = params.length; i < l; i++) {
                relVal += '<br/>' + params[i].marker + params[i].seriesName + ': ' + params[i].value + ' 元'
              }
              return relVal
            }
          },
          legend: {
            data: ['最高价', '最低价', '均价']
          },
          xAxis: {
            name: '日期',
            type: 'category',
            data: valueArr,
            axisLabel: {
              interval: 0,
              rotate: 20,
              textStyle: {
                fontFamily: 'Microsoft YaHei'
              }
            }
          },
          yAxis: {
            name: '单位：元',
            type: 'value'
          },
          series: [
            {
              name: '最高价',
              type: 'bar',
              data: maxNames
            },
            {
              name: '最低价',
              type: 'bar',
              data: minNames
            },
            {
              name: '均价',
              type: 'bar',
              data: avgPrice
            }
          ]
        }
        option && myChart.setOption(option)
      })
    },
    //
    getList () {
      this.zheFn(this.searchFrom)
      this.zhuFn(this.searchFrom)
      this.goodFn(this.searchFrom)
      this.weightFn(this.searchFrom)
      getTrafficCountNoGroup(this.searchFrom).then(res => {
        this.tongji = res[0]
      })
    },
    // 查询
    searchFn () {
      this.getList()
    },
    // 重置
    resetForm (formName) {
      // console.log(this.searchFrom.deliverAddress);
      this.searchFrom = {
        createTimes: null
        // deliverAddress: '',
        // receivingAddress: ''
      }
      //  console.log(this.$refs.reference);
      // this.$nextTick(() => {

      // })
      // this.$refs.reference.$refs.cs.getCheckedNodes()[0].parent.parent.label = ''
      // this.$refs.reference.$refs.cs.getCheckedNodes()[0].parent.label = ''
      // this.$refs.reference.$refs.cs.getCheckedNodes()[0].label = ''

      if (this.$refs.reference) {
        // this.$refs.reference.$refs.cs.checkedValue = []
        this.$refs.reference.$refs.cs.$refs.panel.clearCheckedNodes()
        this.$refs.reference.$refs.cs.$refs.panel.activePath = []
      }

      if (this.$refs.reference1) {
        // this.$refs.reference1.$refs.cs.checkedValue = []
        this.$refs.reference1.$refs.cs.$refs.panel.clearCheckedNodes()
        this.$refs.reference1.$refs.cs.$refs.panel.activePath = []
      }
    }
  }
}
</script>

<style scoped lang='less'>
.whole{
  height: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}
.whole1 {
  height:calc(100% - 40px);
}
.Box3{
  height: 40%;
}
.box1{
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  height: 60%;
  .Boxone {
    width: 70%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  .statistics2 {
    width: 100%;
    height: 70%;  //
  }
  .statistics1 {
    width: 100%;
    height: 30%;  //
    .leiji {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    height: 100%;
    .box1item{
      width: 26%;
      height: 76%;
      border-radius: 4px;
      color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;
      .da{
        font-size: 40px;
      }
      .xiao{
        font-size: 14px;
      }
    }
  }
  }
  .Box2 {
    width: 30%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    .classify1 {
      width: 100%;
      height: 50%;
    }
    .classify2 {
      width: 100%;
      height: 50%;
    }
  }
}
.echarts{
    background: #E5E5E5;
    box-sizing: border-box;
    width:100%;
    margin-top: -12px;
    .item{
      background: #fff;
    }
    .title{
      display: flex;
      justify-content: space-between;
      padding: 0 10px;
      height: 40px;
      align-items: center;
      h4{
        margin: 0;
        font-size: 16px;
        padding: 0;
        border-left: 3px solid #0e6fec;
        padding-left: 10px;
      }
      /deep/.el-input__inner{
          border:none;
          width: 260px;
        }
    }
   .bottom{
     display: flex;
     .left{
       width: 50%;
       margin-right: 8px;
       background: #fff;
     }
     .right{
        width: 50%;
       background: #fff;
     }

   }
}
.searchBox{
  padding-top: 5px;
}
.czlx{
      /deep/.el-form-item__content{
        display: flex;
        align-items: center;
        .fa-arrows-h{
          margin: 0 4px;
        }
      }
    }
 /deep/.el-date-editor .el-range__icon {
    display: none;
}

.diqu1 /deep/ .el-form-item__content .el-input__inner {
    width: 240px;
}

//  /deep/.el-date-editor .el-range__close-icon {
//     display: none;
// }
</style>
